<template>
  <data-section
    theme="red"
    title="商品建議書"
    :datas="datas"
    :_fields="
      [
        {
          name: '險種',
          key: 'productname',
          width: 274,
          sortable: true,
          orderByMultiKey: ['sortProductname'],
          orderByMultiType: ['asc']
        },
        {
          name: '要保人',
          key: 'applicant',
          width: 79,
          sortable: true,
          orderByMultiKey: ['sortApplicant'],
          orderByMultiType: ['asc']
        },
        { name: '繳費\n年期', key: 'year', width: 50 },
        {
          name: '承保\n對象',
          key: 'relation',
          width: 44,
          className: 'text-left'
        },
        {
          name: '建立日期',
          key: 'insurancedate',
          width: 70,
          className: 'text-left',
          sortable: true,
          orderByMultiKey: ['sortInsuranceADDate'],
          orderByMultiType: ['asc']
        },
        {
          name: '保額',
          key: 'amountofinsurance',
          width: 96,
          thClassName: 'text-right',
          className: 'text-right'
        },
        {
          name: '保費/繳別',
          key: 'bknm',
          width: 128,
          className: 'text-right',
          sortable: true,
          orderByMultiKey: [
            'sortBknm',
            'isprimarycontract',
            'money',
            'longPremium'
          ],
          thClassName: 'text-right',
          orderByMultiType: ['asc', 'adesc', 'asc', 'asc']
        },
        { name: '受益人', key: 'bnf', width: 144 }
      ].concat(_fields)
    "
    @toggle="(isShow) => $router.assignQuery({ ProductSuggestShow: isShow })"
    :initShow="$route.query['ProductSuggestShow'] !== 'false'"
  >
    <template scope="props"  v-if="refresh">
      <section
        v-for="(person, index) in props.datas"
        :key="'other' + index"
        class="newTable"
      >
        <data-table
          v-bind="
            Object.assign({}, props, {
              datas: proccessDatas(person)
            })
          "
          @changeSort="
            (sort) =>
              $router.assignQuery({
                [`ProductSuggestSort${index}`]: JSON.stringify(sort)
              })
          "
          :initSort="
            $route.query[`ProductSuggestSort${index}`]
              ? JSON.parse($route.query[`ProductSuggestSort${index}`])
              : {}
          "
        >
          <template slot="thead">
            <thead class="thBorderCustSuggest" style="background-color: white ;background-color: rgb(250, 250, 225);">
              <tr>
                <th colspan="9" style="border: #de4054 1px solid">
                  <div class="font-20 text-center text-black">
                      <strong>
                        被保人：
                        <avatar
                          class="mr-2 mt-1"
                          :gender="
                            Number(person.insuredpersonsex == 'Female' ? 2 : 1)
                          "
                          :size="20"
                        />
                        </strong>
                        <!-- 20210624 個資遮蔽 -->
                        <Tooltip
                          position="top"
                          :id="person.insuredpersonid && !person.insuredpersonid.includes('~')?person.insuredpersonid:''"
                          :birthday="person.insuredpersonbirthday?person.insuredpersonbirthday:''"
                          style="font-size:16px;font-weight: 500;"
                        >
                          <strong
                          
                            style="font-size:20px;"
                          >
                            {{ person.insuredpersonname | truncate}}
                          </strong>
                        </Tooltip>
                    <strong class="ml-3">年齡：</strong>
                    <span class="fw-normal">
                      {{
                        person.insuredpersonage
                          ? person.insuredpersonage
                          : person.insuredpersonbirthday
                          ? moment().diff(
                              person.insuredpersonbirthday,
                              "years"
                            )
                          : "一一"
                      }}歲 ({{
                        person.insuredpersonbirthday
                          ? moment(person.insuredpersonbirthday).getROCDate()
                          : "一一" | getMaskBirthday
                      }})
                    </span>
                    <strong class="ml-3">身分證：</strong>
                    <span class="fw-normal">
                      {{
                        person.insuredpersonid.includes("~")
                          ? "一一"
                          : person.insuredpersonid
                          | getMaskID
                      }}</span
                    >
                  </div>
                </th>
              </tr>
            </thead>
          </template>
          <template slot="productname" scope="item">
            <div v-if="item.data.isprimarycontract">
              <div class="font-13">
                  商品建議書
              </div>        
              <div>
                {{ item.data.productname }}
                {{ item.data.prodid ? `(${item.data.prodid})` : "" }}
              </div>
            </div>
            <div v-else>
              <div style="margin-left: 1em; text-indent: -1em">
                <span style="text-shadow: 0px 1px grey" class="text-gray">
                  <strong>└</strong>
                </span>
                {{ item.data.productname }}
                {{ item.data.prodid ? `(${item.data.prodid})` : "" }}
              </div>
            </div>
          </template>
          <template slot="applicant" scope="item">
            <span v-if="item.data.c111_apc!= ''" >
              {{ item.data.applicant | truncate }}
            </span>
            <div  v-else>
                {{ item.data.applicant | truncate }}
            </div>
          </template>
          <template slot="year" scope="item">
            {{ item.data.year.padLeft(2, "0") }}
            <span v-if="item.data.year_type === '2'">歲</span>
          </template>
          <template slot="amountofinsurance" scope="item">
            <div
              v-if="item.data.schemename && item.data.quantity"
              class="text-right pre-formatted"
            >
              {{
                item.data.schemename && item.data.schemename.includes("_1")
                  ? `計畫${item.data.schemename}：\n`
                  : `計畫${item.data.schemename}：\n日額`
              }}{{ `${item.data.quantity}元` }}
            </div>
            <div v-else class="text-right">
              {{ item.data.amountofinsurance }}
            </div>
          </template>
          <template slot="bknm" scope="item">
            <div v-if="item.data.premium">
              {{ item.data.money }} {{ item.data.premium | numberFormat }}
            </div>
            <div>{{ item.data.paymentway }}</div>
            <div v-if="item.data.bknm || item.data.card_acnt_no">
              {{ `${item.data.bknm}(${item.data.card_acnt_no})` }}
            </div>
          </template>
          <template slot="bnf" scope="item">
            <div
              v-for="(name, key) in {
                bnf_death_nm: '身故',
                bnf_matag_nm: '滿期',
                bnf_annuity_nm: '年金',
                bnf_birth_nm: '祝壽'
              }"
              :key="key"
            >
              <span
                v-if="item.data[key]"
                :set="(names = item.data[key].split(','))"
              >
                {{ name }}：
                <span v-for="(name, index) in names" :key="index">
                  <truncate-tool :content="name"></truncate-tool>
                  {{ names.length - 1 > index ? "、" : "" }}
                </span>
              </span>
            </div>
            <div
              v-if="
                !item.data.bnf_death_nm &&
                !item.data.bnf_matag_nm &&
                !item.data.bnf_annuity_nm &&
                !item.data.bnf_birth_nm
              "
            >
              一一
            </div>
          </template>
        </data-table>
      </section>
    </template>
  </data-section>
</template>

<script>
import InsuranceMixins from "./Insurance";
import TruncateTool from "./TruncateTool";
import Tooltip from '@/desktop/components/ToolTip';
import { mvCommonMixin } from '@/desktop/views/mv/mixins/common';

const { moment } = window;
export default {
  mixins: [InsuranceMixins, mvCommonMixin],
  components: {
    TruncateTool,
    Tooltip
  },
  methods: {
    proccessDatas(person) {
      return person.majorpolicyinfolist
        .map((primary) => {
          const primaryData = primary.policyinfolist[0];
          return primary.policyinfolist.map((data) =>
            Object.assign({}, data, {
              applicant: primary.applicant,
              c111_apc: primary.c111_apc,
              card_acnt_no: primary.card_acnt_no,
              bknm: primary.bknm,
              trClassName: data.isprimarycontract ? "bg-white" : "bg-gray",
              longPremium: data.premium.padLeft(20, "0"),
              sortProductname: this.mergeString(
                primaryData.productname,
                primary.policyid
              ),
              sortApplicant: this.mergeString(
                primary.applicant,
                primary.policyid
              ),
              sortInsuranceADDate: this.mergeString(
                moment(primaryData.insurancedate).getADDate(),
                primary.policyid
              ),
              sortBknm: this.mergeString(
                // 沒有數字可以被放一起
                !primaryData.premium ? "" : "_",
                primaryData.money,
                // 左邊補0讓文字可以被排序
                primaryData.premium.padLeft(20, "0"),
                primary.policyid
              )
            })
          );
        })
        .flat();
    }
  }
};
</script>
